
const etablissementAction = {
};

export default etablissementAction;
